import { render, staticRenderFns } from "./TransactionsTableStatusColumnContent.vue?vue&type=template&id=2d92927a"
import script from "./TransactionsTableStatusColumnContent.vue?vue&type=script&lang=js"
export * from "./TransactionsTableStatusColumnContent.vue?vue&type=script&lang=js"
import style0 from "./TransactionsTableStatusColumnContent.vue?vue&type=style&index=0&id=2d92927a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports